module.exports = __webpack_public_path__ + "static/media/MS_AI_classroomSeries.1059d6b2.png";